// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__ETm6t","container":"styles_container__QksvW","copyAccessToken":"styles_copyAccessToken__3pQCO","submitModal":"styles_submitModal__1SHKb"};